interface RangeInputProps {
  label: string
  value: number
  onChange: (value: number) => void
  min?: number
  max?: number
  leftLabel?: string
  rightLabel?: string
}

export function RangeInput({ label, value, onChange, min = 0, max = 10, leftLabel, rightLabel }: RangeInputProps) {
  return (
    <label className="range-field">
      <span className="range-field__top"><span>{label}</span><strong>{value}</strong></span>
      <input type="range" min={min} max={max} value={value} onChange={(event) => onChange(Number(event.target.value))} />
      {(leftLabel || rightLabel) && <span className="range-field__labels"><span>{leftLabel}</span><span>{rightLabel}</span></span>}
    </label>
  )
}
